module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADZSURBVHgB7dixDYMwEAXQs1kkIzBCOkTJCJksI6RE7jICI2QR27FbxF2k5PAR9F9DcULwjS19QQQAYMmRsnmeL13X3XPO19VoSSlN4zi+SJEnZd77x8bLV30NRsrUAxQ9N2CC/WSPAE0hgDUEsIYA1hDAGgJYY9uo0CpbE1ss+wWEVtma2GKlLdTTQUgLiUNs7bwByr570kE45xZuJgW4lQt7Yyt1IWOMEzdX/ysRQsjSfBgG1WfiEFtDAGsIYA0BrCGANQRYk1qs1Cq/tUeAzRb7qVUCAPynN/DXTDq0YJ9jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/addMethod@2x.png
// module id = 1826
// module chunks = 0